import { TranslatePipe } from '../../filters/translate.pipe';
import { CardInvoicesComponent } from '../../components/card-invoices/card-invoices.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'invoices',
	templateUrl: './invoices.component.html',
	imports: [ CommonModule, TranslatePipe, CardInvoicesComponent, FormsModule ]
})
export default class InvoicesView implements OnInit {
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('invoices').then(() => {
			
		});
	}
	
}